import createReactComponent from '../createReactComponent';
export default createReactComponent('asterisk-circle', 'AsteriskCircle', [["path",{"d":"M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0m-9-3.5v7m-3-1.75 6-3.5m-6 0 6 3.5","key":"svg-0"}]]);